'use strict';

var angular = require('angular');
var RuleCustomDirective = function RuleCustomDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/rule-custom.html'),
    controller: 'RuleCustomController',
    scope: {
      closePanelHandler: '&',
      rule: '=?'
    },
    link: function link(scope, element) {
      element.find('.gdpr-popover').popover();
      scope.$watch('rule.primaryCriteriaLevel', scope.onPrimaryCriteriaSelectedLevelChanged);
      scope.$watch('rule.linkCriteriaLevel', scope.onLinkCriteriaSelectedLevelChanged);
      scope.$watch('rule.linkCriteriaEnabled', scope.onLinkCriteriaEnabledChanged);
      scope.showConfirmationDialog = function () {
        angular.element('#criteria-rule-custom-modal').appendTo('body').modal('show');
      };
      scope.hideConfirmationDialog = function () {
        angular.element('#criteria-rule-custom-modal').modal('hide');
        angular.element('body').removeClass('modal-open');
        angular.element('#criteria-rule-custom-modal, .modal-backdrop').remove();
      };
    }
  };
};
RuleCustomDirective.$inject = [];
module.exports = RuleCustomDirective;